import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_EFT: unique symbol = symbolName("eft");
